

  // import ssoImg1 from "./../../../../assets/images/708.png"; // Adjust the path as necessary
  // import ssoImg2 from "./../../../../assets/images/283.png"; // Adjust the path as necessary
  import img01 from "./../../../assets/images/WelfareMeals.png";// Adjust the path as necessary
  
  function AboutSeafarerWelfare() {
    return (
      <>
        <div className="service-title font-700 mb-3 text-uppercase">
          Seafarer Welfare
          <span className="text-orange-ef3e33 font-400"> Overview</span>
        </div>
  
        <div className="row g-3 g-sm-4 g-md-5">
          <div className="col-lg">
             <div className="service-title font-700 mb-3 text-uppercase">
                {/* Seafarer Welfare */}
                {/* <span className="text-orange-ef3e33 font-400"> Crew complaints</span> */}
              </div>
  
            <p className="text-primary-color mb-3">
              In this portal seafarer means a “seafarer” as defined by the Merchant Shipping Act. No 57 of 1951 (includes fishers).
             </p>
            <p className="text-primary-color mb-3">
             SAMSA has a mandate to enforce compliance within the maritime labour legislation in all South African Ports and harbours.</p>
  <p className="text-primary-color mb-3">
             South Africa has an obligation under the Merchant Shipping Act to look after the welfare of South African seafarers and foreign seafarers working on South African flagged vessels. South Africa has an additional obligation under international conventions to look after the welfare of seafarers visiting the ports/harbours within its territory. The two maritime labour conventions with objectives of ensuring that seafarers have decent working conditions on board vessels are the Maritime Labour Convention, 2006 (all seafarers except fishers) and the Working in Fishing Convention C188, 2007 (fishers).  South Africa has ratified both the conventions, and they are both schedules to the Merchant Shipping Act. </p>
           
  
            {/* <ul class="green-star-ul">
              <li>In reporting Crew complaints that falls within MLC kindly ensure that you have followed the guidelines provided in Marine Notice No. 48 of 2020 – Onboard Complaints Procedure. </li>
                
            </ul>   */}
            
                 
  
          </div>
          <div className="col-lg-5">
            <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
              <div className="col-lg-12 col-md-6 col-sm-6">
                <img src={img01} className="img-fluid rounded-1" alt="" />
              </div>
              {/* <div className="col-lg-12 col-md-6 col-sm-6">
                <img src={img01} className="img-fluid rounded-1" alt="" />
              </div> */}
            </div>        
          </div>
           
        </div>
         {/* <p className="text-primary-color mb-3">
              South Africa has an obligation under the Merchant Shipping Act to look after the welfare of South African seafarers and foreign seafarers working on South African flagged vessels. South Africa has an additional obligation under international conventions to look after the welfare of seafarers visiting the ports/harbours within its territory. The two maritime labour conventions with objectives of ensuring that seafarers have decent working conditions on board vessels are the Maritime Labour Convention, 2006 (all seafarers except fishers) and the Working in Fishing Convention C188, 2007 (fishers).  South Africa has ratified both the conventions, and they are both schedules to the Merchant Shipping Act.
            </p> */}
         <div className="accordion blackTab" id="blackTab">
                      <div className="accordion-item">
                       <h2 className="accordion-header">
                          <button className="accordion-button collapsed"
                           type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#blackTabOne"
                            aria-expanded="false"
                            aria-controls="blackTabOne">
                            What is seafarer welfare?</button>
                        </h2>
                        <div id="blackTabOne"
                           className="accordion-collapse collapse"
                            data-bs-parent="#blackTab">
                            <div className="accordion-body">
                            <p className="mb-3">
                              Seafarer welfare encompasses the well-being of maritime workers, ensuring their physical, mental, and social health, as well as fair labour practices and decent working conditions
                           </p>
                         </div>
                       </div>
                      </div>
                      </div>
                 <p className="text-primary-color mb-3">
                   What is seafarer welfare? - Seafarer welfare encompasses the well-being of maritime workers, ensuring their physical, mental, and social health, as well as fair labour practices and decent working conditions</p>
                 <p className="text-primary-color mb-3">
                    SAMSA has established a seafarer welfare programme in line with section 3, objective 1 and 3 of the SAMSA Act. The programme focuses on the following:
                  </p>
                  <ul class="green-star-ul">
                      <li>South African seafarer welfare including foreign seafarers working on South African vessels.
                       </li>
                     <li>Seafarer Welfare of international seafarers visiting South Africa’s Ports and harbours</li> 
                      <li>South African seafarers regardless of the status of the vessel and their location – (in this case SAMSA has limited jurisdiction).</li> 
                    </ul>  
          
  
      </>
    );
  }
export default AboutSeafarerWelfare;